import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M13 21h-7a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v6.5","key":"svg-0"}],["path",{"d":"M16 3v4","key":"svg-1"}],["path",{"d":"M8 3v4","key":"svg-2"}],["path",{"d":"M4 11h16","key":"svg-3"}],["path",{"d":"M22 22l-5 -5","key":"svg-4"}],["path",{"d":"M17 22l5 -5","key":"svg-5"}]]

const IconCalendarX = createReactComponent('outline', 'calendar-x', 'CalendarX', __iconNode);

export default IconCalendarX;